import { useContext } from 'react';
import { addTocartBogoHandler } from '../../../Utils/productAction';
import { AddToCartButtonFilled } from '../../StoreCategoryPage/SubCategoryProducts/styled';
import { CssLoader } from '../AddToCartButton/styled';
import { getProductIds } from './common';
import { fireAddProductEvent } from './instrumentation';
import CardContext from '../ProductCard/ProductCardContext';

export default function AddButton(props) {
  const { isForNewCdPage } = props;
  const contextData = useContext(CardContext);
  const {
    setChangeCartCount,
    productData,
    setOfferCartData,
    offerCartData,
    loaderState,
    setLoaderState,
  } = contextData;
  const productId = productData?.id;
  const offerCode = offerCartData?.offerData?.offerCode;

  const AddProductHandler = async () => {
    setLoaderState('loading');
    fireAddProductEvent(productData, productId, offerCode);
    const params = {
      productId: productId,
      ids: getProductIds(offerCartData?.productList),
      add: false,
      less: false,
      addToCart: true,
      selectedProductId: productId,
    };
    if (setChangeCartCount) {
      setChangeCartCount(true);
    }
    const data = await addTocartBogoHandler(params);
    setOfferCartData(data?.data);
    setLoaderState('loaded');
  };

  return (
    <AddToCartButtonFilled
      onClick={() => AddProductHandler()}
      className="add_btn_filled"
      bogo
      loaderState={loaderState}
      isForNewCdPage={isForNewCdPage}
    >
      {loaderState === 'loading' || loaderState === 'loaded' ? (
        <CssLoader
          bogo
          className={loaderState === 'loaded' ? 'load-complete' : ''}
          borderColor="#fff"
        >
          <div
            className="checkmark draw"
            style={
              loaderState === 'loaded'
                ? { display: 'block', color: '#fff' }
                : {}
            }
          ></div>
        </CssLoader>
      ) : (
        'SELECT'
      )}
    </AddToCartButtonFilled>
  );
}
